<template>
  <tr v-if="isEditMode">
    <td>
      <v-text-field
        ref="title"
        v-model="title"
        :rules="titleRules"
        required
      ></v-text-field>
    </td>
    <td>
      <v-select
        :items="availableColorSchemes"
        v-model="draft.colorScheme"
        placeholder="Select color"
        item-text="title"
        item-value="color"
        clearable>
        <template slot="item" slot-scope="data">
          <v-list-tile-content>
            <v-list-tile-title>
              <i class="fas fa-square-full" v-bind:style="{ color: data.item.color}"></i>
              <span class="ml-2 color-scheme-title">{{data.item.title}}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </template>
        <template slot="selection" slot-scope="data">
          <v-list-tile-content>
            <v-list-tile-title>
              <i class="fas fa-square-full" v-bind:style="{ color: data.item.color}"></i>
              <span class="ml-2 color-scheme-title">{{data.item.title}}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </template>
      </v-select>
    </td>
    <td class="text-right">
      <v-btn flat icon color="green lighten-2" @click="handleSaveClickButton">
        <v-icon>fas fa-check</v-icon>
      </v-btn>
      <v-btn flat icon color="red lighten-2" class="ml-0" @click="handleEditClickButton">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </td>
  </tr>
  <tr v-else>
    <td>{{ item.title }}</td>
    <td>
      <div v-if="item.colorScheme">
        <i class="fas fa-square-full" v-bind:style="{ color: availableColorSchemeByColor(item.colorScheme).color}"></i>
        <span class="ml-2 color-scheme-title">{{ availableColorSchemeByColor(item.colorScheme).title }}</span>
      </div>
      <div v-else>
        Not set
      </div>
    </td>
    <td class="text-right">
      <v-btn flat icon color="black lighten-2" class="mr-0" @click="handleEditClickButton">
        <v-icon small>fas fa-pencil-alt</v-icon>
      </v-btn>
      <v-btn flat icon color="black lighten-2" class="ml-0" @click="handleDeleteButtonClick">
        <v-icon small>fas fa-trash-alt</v-icon>
      </v-btn>
      <confirm ref="confirm"></confirm>
    </td>
  </tr>
</template>

<script>
import {validateStringLength} from '../../helpers/validation'
import Confirm from '../Ui/Confirm'
import _ from 'lodash'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'service-group-item',
  props: {
    item: {
      type: Object
    }
  },
  components: {
    Confirm
  },
  filters: {},
  data () {
    return {
      validatableRefs: ['title'],
      isEditMode: false,
      draft: {
        id: this.item.id,
        title: this.item.title,
        colorScheme: this.item.colorScheme
      },
      titleRules: [
        _.partial(validateStringLength, _, 255, 'The length of the title should be no more than 255 characters')
      ]
    }
  },
  beforeCreate () {

  },
  computed: {
    ...mapState({
      availableColorSchemes: 'availableColorSchemes'
    }),
    ...mapGetters({
      availableColorSchemeByColor: 'availableColorSchemeByColor'
    }),
    title: {
      get: function () {
        return this.item.title
      },
      set: function (newValue) {
        this.draft.title = newValue
      }
    },
    colorScheme: {
      get: function () {
        return this.item.colorScheme
      },
      set: function (newValue) {
        this.draft.colorScheme = newValue
      }
    }
  },
  watch: {},
  mounted () {
  },
  methods: {
    ...mapActions({
      serviceGroupsUpdate: 'serviceGroupsUpdate',
      serviceGroupsDelete: 'serviceGroupsDelete'
    }),
    handleEditClickButton () {
      this.isEditMode = !this.isEditMode
    },
    async handleSaveClickButton () {
      for (let refName of this.validatableRefs) {
        if (!this.$refs[refName].validate(true)) {
          return false
        }
      }

      try {
        await this.serviceGroupsUpdate({
          id: this.item.id,
          title: this.draft.title,
          colorScheme: this.draft.colorScheme
        })
      } catch (e) {
        this.reset()
      }

      this.isEditMode = false
    },
    async handleDeleteButtonClick () {
      this.$refs.confirm.open('Delete service group', `Do you want to delete service group with title: "${this.item.title}"?`, {width: 600}).then(async (confirm) => {
        if (!confirm) {
          return
        }

        try {
          await this.serviceGroupsDelete(this.item)
        } catch (e) {
          console.log(e)
        }
      })
    },
    reset () {
      this.draft.id = this.item.id
      this.draft.title = this.item.title
      this.draft.colorScheme = this.item.colorScheme
    }
  }
}
</script>

<style>
  .color-scheme-title {
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sales/ServiceGroupItem.vue